import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const getCertificateApi = createAsyncThunk(
  "auth/setting/certificateGet",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.get(apiRoutes.courseCertificateList);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const settingSlice = createSlice({
  name: "certificate",
  initialState: { result: [], loading: false, error: null, message: "" },
  extraReducers: (builder) => {
    builder.addCase(getCertificateApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getCertificateApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(getCertificateApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});

export const certificateReducer = settingSlice.reducer;
